import type { Color, Colors } from '@shared/types/types.ts';

/**
 *
 *
 *
 */
export function sortedColorsWithBestVariationFirst(
    colors?: Colors,
    bestVariationId?: string,
): [string, Color][] | undefined {
    if (!colors || !bestVariationId) return;

    const colorEntries = Object.entries(colors);

    if (colorEntries.length === 0) return;

    /*                                                   */
    const bestVariationIndex = colorEntries.findIndex(([id]) => id === bestVariationId);

    if (bestVariationIndex !== -1) {
        /*                                               */
        const [bestEntry] = colorEntries.splice(bestVariationIndex, 1);
        bestEntry[1].selected = true; /*                  */
        colorEntries.unshift(bestEntry);
    } else {
        /*                                                                          */
        colorEntries.sort((a, b) => (a[1].selected ? -1 : b[1].selected ? 1 : 0));
        colorEntries[0][0] = bestVariationId; /*                                               */
        colorEntries[0][1].selected = true; /*                                           */
    }

    return colorEntries;
}
